import { getConferenceCampaign } from "../../../../src/shared/conferenceCampaign";

export const shouldRequireAnnualOnly = ({ user, annualParam, annualCookie, subscription }) => {
  if (getConferenceCampaign(subscription?.data?.conferenceCampaign?.id)) return false;
  const loggedOutAnnual = !user && (annualParam === "true" || annualCookie === "true");
  const subscriptionAnnual = subscription?.data?.features?.requiresAnnualOnly && !subscription?.hasPaid;

  return !!(loggedOutAnnual || subscriptionAnnual);
};
